export default __webpack_public_path__ + "static/media/38.640f58ed.png";